<span
  class="statement-inline-value"
  *ngFor="let item of items; let i = index"
>
  {{ 'Statement.Form.' + item.name | translate }}<span *ngIf="i < items.length - 1">, </span>
</span>
